module.exports = __webpack_public_path__ + "img/MG.610912b5.webp";